import React from 'react';
import PropTypes from 'prop-types';

import AutoLayoutsToggle from './components/AutoLayoutsToggle';
import Button from '../../../../../../../../../../components/global/Button';
import { ALBUM_SLIDESHOW_MODE } from '../../../../../../../../../../constants/albums';
import SlidesSection from './components/SlidesSection/SlidesSection';
import {
  isAutoLayoutsSlideshow,
  isSelectedPhotosSlideshow,
} from '../../../../../../../../../../util/album';

const propTypes = {
  saving: PropTypes.bool.isRequired,
  slideshow: PropTypes.shape({
    mode: PropTypes.oneOf(Object.values(ALBUM_SLIDESHOW_MODE)),
  }).isRequired,
  slideshowSlides: PropTypes.array.isRequired,
  slidesTotal: PropTypes.number.isRequired,
  slidesOffset: PropTypes.number.isRequired,
  currentSlideId: PropTypes.string.isRequired,
  hasIntroSlide: PropTypes.bool.isRequired,
  onIntroSlideCreate: PropTypes.func.isRequired,
  onSlideshowUpdate: PropTypes.func.isRequired,
  loadingMore: PropTypes.bool.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  onDeletePhoto: PropTypes.func.isRequired,
  onMoveSlide: PropTypes.func.isRequired,
  onReorderSlides: PropTypes.func.isRequired,
  onDeleteLayout: PropTypes.func.isRequired,
  onThumbnailClick: PropTypes.func.isRequired,
};

const SlidesStep = ({
  saving,
  slideshow,
  slideshowSlides,
  slidesTotal,
  slidesOffset,
  currentSlideId,
  hasIntroSlide,
  onIntroSlideCreate,
  onSlideshowUpdate,
  loadingMore,
  onLoadMore,
  onDeletePhoto,
  onMoveSlide,
  onReorderSlides,
  onDeleteLayout,
  onThumbnailClick,
}) => {
  const onAlbumSlideshowModeToggle = () => {
    if (saving) {
      return;
    }

    if (!slideshow) {
      return;
    }

    const isAutoLayouts = isAutoLayoutsSlideshow(slideshow);
    const isSelectedPhotos = isSelectedPhotosSlideshow(slideshow);

    if (!isAutoLayouts) {
      onSlideshowUpdate({
        mode: isSelectedPhotos
          ? ALBUM_SLIDESHOW_MODE.SELECTED_PHOTO_LAYOUTS
          : ALBUM_SLIDESHOW_MODE.AUTO_LAYOUTS,
        createAutoLayouts: !isSelectedPhotos,
        createSelectedPhotoLayouts: isSelectedPhotos,
      });
    } else {
      onSlideshowUpdate({
        mode: isSelectedPhotos
          ? ALBUM_SLIDESHOW_MODE.SELECTED_PHOTOS
          : ALBUM_SLIDESHOW_MODE.ALL_PHOTOS,
      });
    }
  };

  return (
    <div className="secondary-photos-view-slides">
      <AutoLayoutsToggle
        disabled={saving}
        onToggleAutoLayoutsMode={onAlbumSlideshowModeToggle}
        albumSlideshowMode={slideshow?.mode}
      />
      {!hasIntroSlide && onIntroSlideCreate && (
        <div className="mb-2">
          <p className="text-uppercase text-light text-extra-bold text-xs mb-1">
            Cover Slide
          </p>
          <Button
            btnStyle="reset"
            onClick={onIntroSlideCreate}
            className="secondary-photos-view-slides-step-create"
          >
            Create
          </Button>
        </div>
      )}
      <SlidesSection
        hasIntroSlide={hasIntroSlide}
        slidesTotal={slidesTotal}
        slidesOffset={slidesOffset}
        currentSlideId={currentSlideId}
        loadingMore={loadingMore}
        onLoadMore={onLoadMore}
        onDeletePhoto={onDeletePhoto}
        slideshowSlides={slideshowSlides}
        onMoveSlide={onMoveSlide}
        onReorderSlides={onReorderSlides}
        onDeleteLayout={onDeleteLayout}
        onThumbnailClick={onThumbnailClick}
      />
    </div>
  );
};

SlidesStep.propTypes = propTypes;

export default SlidesStep;
